export default "__VITE_ASSET__DvNgO4sA__"